export default __webpack_public_path__ + "static/alacaza-7385b123706340f9c341a1670aabe275.svg";